import React from 'react';
import { Box, Typography, Container, Paper, useTheme } from '@mui/material';
import { GradientText } from '../components/ui/GradientText';
import ConstructionIcon from '@mui/icons-material/Construction';

/**
 * Terms of Service placeholder page
 * Will be replaced with actual content when ready
 */
export const TermsOfServicePage: React.FC = () => {
  const theme = useTheme();

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          py: { xs: 8, md: 12 },
          background: `linear-gradient(180deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
          textAlign: 'center',
        }}
      >
        <Container maxWidth="md">
          <GradientText
            variant="h1"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '2.5rem', md: '3rem' },
            }}
          >
            Terms of Service
          </GradientText>
        </Container>
      </Box>

      {/* Content Section */}
      <Box sx={{ py: { xs: 6, md: 8 }, bgcolor: 'background.paper' }}>
        <Container maxWidth="md">
          <Paper
            elevation={2}
            sx={{
              p: { xs: 4, md: 6 },
              borderRadius: 3,
              textAlign: 'center',
            }}
          >
            <ConstructionIcon
              sx={{
                fontSize: 64,
                color: 'primary.main',
                mb: 3,
              }}
            />

            <Typography variant="h4" sx={{ fontWeight: 600, mb: 2 }}>
              Coming Soon
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ maxWidth: 500, mx: 'auto', lineHeight: 1.7 }}
            >
              We are currently finalizing our Terms of Service document. This page will be updated
              with comprehensive information about the terms and conditions for using Lecturo.
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
              For immediate inquiries, please contact us at{' '}
              <Box
                component="a"
                href="mailto:situn3708@uib.no"
                sx={{
                  color: 'primary.main',
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                situn3708@uib.no
              </Box>
            </Typography>
          </Paper>
        </Container>
      </Box>
    </Box>
  );
};
